<!--
 * @Author: your name
 * @Date: 2020-12-06 17:47:20
 * @LastEditTime: 2021-01-15 18:57:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/pages/orderForChat/orderList.vue
-->
<template>
  <div class="orderList">
    <el-row :gutter="20" class="my-wrap">
      <el-col :span="17" class="index-left">
        <el-col :span="9" class="index-lists">
          <div class="list-search">
            <el-row>
              <el-col :span="24">
                <el-input
                  class="my-input"
                  clearable
                  v-model="myInput"
                  :placeholder="placeholder || '输入问题单号按回车查询'"
                  prefix-icon="el-icon-search"
                  :showArrow="false"
                  @change="onListSearch"
                >
                </el-input>
              </el-col>
            </el-row>
          </div>
          <div class="lists">
            <div
              v-if="lists.length === 0"
              class="my-popover empty-wrapper"
            >
              <img :src="image.noData" alt="" />
              <p>暂无数据</p>
            </div>
            <ul v-infinite-scroll="getGroupLists" infinite-scroll-disabled="infiniteDisabled" v-if="lists.length > 0">
              <li
                v-for="(item, index) in lists"
                :key="index"
                type="flex"
                class="list"
                :class="item.active ? 'active' : ''"
                @click="toListDetail(item, index)"
              >
                <el-col :span="5">
                  <el-avatar
                    :size="45"
                    class="list-avatar"
                    :src="image.groupAvatar"
                  />
                </el-col>
                <el-col :span="19"  style="padding-left: 0; padding-right: 0px;">
                  <el-row type="flex" justify="space-between">
                    <el-col class="list-title">
                      {{ item.exceptionOrderNo }}
                      <!-- <el-tag
                        class="my-tag"
                        style="margin-left: 5px"
                        v-if="item.operatorId === myUserId"
                        type="warning"
                        >我处理</el-tag
                      > -->
                    </el-col>
                    <el-col :span="4" style="margin-top: 5px;">
                      <el-tag class="my-tag list-time" :type="item.orderType | filterOrderTypeColor">
                        {{ item.orderType | filterOrderType }}
                      </el-tag>
                    </el-col>
                  </el-row>
                  <div class="list-subtitle">
                    <div class="list-desc">
                      {{item.description}}
                    </div>
                    <!-- <el-tag
                      class="my-tag"
                      :type="item.chatGroupId ? 'success' : 'danger'"
                      >{{
                        item.chatGroupId ? "已创建聊天" : "未创建聊天"
                      }}</el-tag
                    >
                    <el-tag class="my-tag" type="warning">
                      {{ item.status | filterStatus }}
                    </el-tag> -->
                  </div>
                </el-col>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="15" class="index-chat">
          <div v-if="isClick" class="chatIframe">
            <iframe
              v-if="isChatShow"
              id="iframeId"
              ref="iframe"
              :src="iframeUrl"
              frameborder="0"
              style="background-color: #ffffff; width: 100%; height: 100%"
              @load="iframeLoad"
            >
            </iframe>
            <div v-else>
              <div class="not-chat-wrapper">当前问题单未创建群聊</div>
            </div>
          </div>
          <div v-else class="not-chat-wrapper">
            请点击左边列表项显示聊天内容
          </div>
        </el-col>
      </el-col>
      <el-col :span="7" class="index-right">
        <el-tabs type="card">
          <el-tab-pane key="1" :label="tabName1" class="tabContent">
            <el-form label-width="80px">
              <el-form-item label="异常类型" class="clearfix">
                <span class="bold">{{ abnormalOption.type | filterType }}</span>
              </el-form-item>
              <el-form-item label="处理状态" class="clearfix">
                <el-tag
                  v-if="abnormalOption.processStatus"
                  class="my-tag"
                  type="success"
                  >{{ abnormalOption.processStatus }}</el-tag
                >
              </el-form-item>
              <el-form-item label="异常描述" class="clearfix">
                {{ abnormalOption.description }}
              </el-form-item>
              <el-form-item label="当前处理人" class="clearfix">
                {{
                  abnormalOption.handler ? abnormalOption.handler.handler : ""
                }}
              </el-form-item>
              <el-form-item label="创建人" class="clearfix">
                {{ abnormalOption.created.createdByName }}
              </el-form-item>
              <el-form-item label="解决时间" class="clearfix">
                {{
                  abnormalOption.handler
                    ? abnormalOption.handler.resolutionTime
                    : ""
                }}
              </el-form-item>
              <el-form-item label="更新时间" class="clearfix">
                {{
                  abnormalOption.handler
                    ? abnormalOption.handler.lastUpdatedAt
                    : ""
                }}
              </el-form-item>
              <el-form-item label="创建时间" class="clearfix">
                {{ abnormalOption.created.createdAt }}
              </el-form-item>
              <div class="clearfix">
                <div class="log-title">操作日志</div>
                <div class="log-content">
                  <div
                    v-if="abnormalOption.operations.length === 0"
                    class="my-popover empty-wrapper"
                  >
                    <img :src="image.noData" alt="" />
                    <p>暂无数据</p>
                  </div>
                  <ul v-if="abnormalOption.operations.length > 0" class="my-popover">
                    <el-row
                      class="li"
                      v-for="(item, index) in abnormalOption.operations"
                      :key="index"
                    >
                      <el-col :span="3"
                        ><el-avatar :src="image.groupAvatar" class="log-avatar"
                      /></el-col>
                      <el-col :span="16">
                        <span class="log-name">{{ item.operatorName }}</span>
                        <div class="log-description">
                          {{ item.content }}
                        </div>
                      </el-col>

                      <span class="log-time">{{ item.createdAt }}</span>
                    </el-row>
                  </ul>
                </div>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane key="2" :label="tabName2" class="tabContent">
            <el-form label-width="80px">
              <el-form-item label="锐锢编码" class="clearfix">
                {{ afterOrderOption.bianma }}
              </el-form-item>
              <el-form-item label="商品名称" class="clearfix">
                {{ afterOrderOption.iName }}
              </el-form-item>
              <el-form-item label="商品单位" class="clearfix">
                {{ afterOrderOption.unitName }}
              </el-form-item>
              <el-form-item label="商品单价" class="clearfix">
                <span class="bold">¥ {{ afterOrderOption.purchasePrice }}</span>
              </el-form-item>
              <el-form-item label="申请数量" class="clearfix">
                <span class="bold">{{ afterOrderOption.countMin }}</span>
              </el-form-item>
              <el-form-item label="申请金额" class="clearfix">
                <span class="bold">{{ afterOrderOption.totalMoney }}</span>
              </el-form-item>
              <el-form-item label="问题描述" class="clearfix">
                {{ afterOrderOption.description }}
              </el-form-item>
              <el-form-item label="售后图片" class="clearfix">
                <span v-if="afterOrderOption.imgs.length === 0"
                  >暂时不提供图片</span
                >
                <img
                  v-else
                  class="small-image"
                  v-for="(item, index) in afterOrderOption.imgs"
                  :key="index"
                  :src="item"
                  @click="imagePreview(item)"
                  alt=""
                />
              </el-form-item>
              <el-form-item label="物流单号" class="clearfix">
                {{ afterOrderOption.fromBillNo }}
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="imgPreview" title="图片预览" :modal="false" width="40%" custom-class="custom-dialog">
      <img :src="dialogSrc"/>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrderList,
  getAbnormalDetail,
  getAfterOrderDetail,
} from "@/models/exceptionModel";
import { profilesDefault } from "@/models/profileModel";
import { getDefaultUser } from "@/models/chatModel";
import { eventBus } from "@/event-bus";

// const TOKEN = localStorage.getItem("token");
const CHAT_URL = chathost;

export default {
  name: "orderList",
  data() {
    return {
      TOKEN: localStorage.getItem("token"),
      appCode: 1, // 1，异常单
      userType: 1, // 用户类型：1.大菠萝店铺 2.中台 3.客户
      groupType: 1, // 1.普通群组
      myChatId: "",
      myUserId: parseInt(localStorage.getItem("supplier_id")),
      // myAvatar: userInfo.avatar,
      myNickName: localStorage.getItem("username"),
      isChatNews: 0, // 是否查询所有供应商数据 1.所有供应商 0.登录人所负责供应商, 默认为0

      myInput: "", // 列表搜索关键字
      lists: [],
      placeholder: "",

      isClick: false,
      isChatShow: false,
      // allowCreateChat: false,
      iframeUrl: "",
      addressList: [],

      tabName1: "异常单详情",
      tabName2: "售后单详情",
      abnormalOption: {
        type: "",
        description: "",
        created: {
          createdAt: "",
          createdByName: "",
        },
        handler: {
          handler: "",
          lastUpdatedAt: "",
          resolutionTime: ""
        },
        operations: [],
        processStatus: "",
        status: "",
      },
      afterOrderOption: {
        bianma: "",
        countMin: null,
        description: "",
        fromBillNo: "",
        iName: "",
        imgs: [],
        purchasePrice: null,
        totalMoney: null,
        unitName: "",
      },
      imgPreview: false,
      dialogSrc: '', // dialog 图片地址

      enable: 1, // profile 接口默认查询启用用户 0:全部，1:只有启用
      departmentStrategy: {
        all: 0,
        depth: [2, 2],
      },
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      image: {
        groupAvatar: require("@/assets/img/group-avatar.png"),
        noData: require("@/assets/img/no-data.png"),
      },
      pagination: {
        page: 0,
        total: 0,
        totalPages: 0,
        pageSize: 100
      },
      infiniteLoading: false,
      infiniteNomore: false,
    };
  },
  computed: {
    infiniteDisabled() {
      return this.infiniteLoading || this.infiniteNomore
    }
  },
  watch: {
    $route (value) {
      this.watchRoute(value, 'needQuery')
    },
  },
  activated() {
    this.TOKEN = localStorage.getItem("token");
  },
  created() {
    if (!this.myNickName || !this.myUserId) {
      this.$message.error("当前用户基本信息获取失败！");
    }
    this.watchRoute(this.$route)
    this.init();
    window.addEventListener("message", this.receiveMessage, false); // 监听 iframe 发送过来的数据
    // this.initAllProfile(); // 初始化全量用户信息，保存到 localStorage
  },
  mounted() {
    // 监听 WebSocket 收到消息
    eventBus.$on("rcdMsg", (message) => {
      // console.log('ws收到的消息emit接收： ', JSON.parse(message));
      const data = {
        // message: JSON.parse(message),
        message: message,
      };
      if (this.$refs.iframe) {
        this.onPostMessage("rcdMsg", data);
      }
    });
  },
  methods: {
    /**
     * @description: 初始化页面
     * @param {*}
     * @return {*}
     */
    init() {
      // this.keyWord = this.placeholder = this.$route.query.keyWord;
      this.pagination.current = 1;
      this.isClick = false;
      this.getChatId();
      if (this.myChatId) {
        this.getGroupLists(); // 获取群列表
        this.initAbnormalOption(); // 初始化异常单详情
        this.initAfterOrderOption(); // 初始化售后单详情
      } else {
        const T = setInterval(() => {
          this.getChatId();
          if (this.myChatId) {
            clearInterval(T);
            this.getGroupLists();
            this.initAbnormalOption(); // 初始化异常单详情
            this.initAfterOrderOption(); // 初始化售后单详情
          }
        }, 100);
      }
    },
    /**
     * @description: 监听路由
     * @param {*}
     * @return {*}
     */
    watchRoute(value, query) {
      if (value.fullPath === '/orderList/chat') {
        // 点击菜单打开列表
        this.isChatNews = 0; // 1.所有供应商 0.登录人所负责供应商
        this.keyWord = undefined;
        this.supplierId = undefined;
        this.lists = [];
        if (query === 'needQuery') {
          this.init();
        }
      } else {
        // 打开未读消息列表
        this.isChatNews = 1; // 1.所有供应商 0.登录人所负责供应商
        this.keyWord = value.query.keyWord;
        this.supplierId = undefined;
        this.lists = [];
        if (query === 'needQuery') {
          this.init();
        }
      }
    },
    /**
     * @description: iframe 加载完成回调事件
     * @param {*}
     * @return {*}
     */
    iframeLoad() {
      console.log("===========iframe loaded===========");
      if (
        !this.groupId ||
        !this.exceptionOrderNo ||
        !this.userType ||
        !this.appCode ||
        !this.status
      ) {
        this.$message.error("初始化聊天室数据获取失败");
        return false;
      }
      // 聊天室初始化数据
      const data = {
        groupId: this.groupId,
        billNo: this.exceptionOrderNo,
        userType: this.userType,
        appCode: this.appCode,
        status: this.status,
        myNickName: this.myNickName,
        myUserId: this.myUserId,
        myAvatar: this.myAvatar,
      };
      this.onPostMessage("init", data);
      // 同步 webSocket 状态
      const wsdata = {
        name: "WSreadyState",
        data: sessionStorage.getItem("WSreadyState") || null,
      };
      this.onPostMessage("updateSessionStorage", wsdata);
    },
    /**
     * @description: 接收 iframe postMessage 的消息
     * @param {*}
     * @return {*}
     */
    receiveMessage(event) {
      // const origin = event.origin || event.originalEvent.origin;
      // if (origin !== process.env.VUE_APP_ORIGIN) {
      //   console.log('postMessage的来源非法')
      //   return;
      // }
      const type = event.data.type;
      const data = event.data.data;
      // 根据不同 type 分别执行不同的指令
      if (type === "getDefaultUser") {
        this.getUser(); // 请求聊天室默认用户
      }
      if (type === "updateAlertList") {
        console.log("客服系统收到要更新alert列表的通知");
        eventBus.$emit("updateAlertList");
      }
    },
    /**
     * @description: 列表输入框回车搜索
     * @param {*}
     * @return {*}
     */
    onListSearch() {
      // if (!this.myInput.trim()) {
      //   this.$message.info('请输入搜索内容');
      //   return
      // }
      this.lists = [];
      this.isChatNews = 0;
      this.keyWord = this.myInput;
      this.supplierId = undefined;
      this.getGroupLists();
    },
    /**
     * @description: 查询群组列表
     * @param {*}
     * @return {*}
     */
    getGroupLists({
      page = this.pagination.page,
      pageSize = this.pagination.pageSize,
    } = {}) {
      // console.log("========getGroupLists========");
      this.infiniteLoading = true;
      const params = {
        page: page,
        size: pageSize,
        isChatNews: this.isChatNews,
        userId: this.myUserId,
        userType: this.userType,
        keyWord: this.keyWord
          ? this.keyWord
          : this.myInput.trim()
            ? this.myInput.trim()
            : undefined,
        supplierId: this.supplierId || undefined,
      };
      getOrderList(params)
        .then((res) => {
          this.lists = this.lists.concat(res.content || []).map((item) => {
            item.active = false;
            return item;
          });
          this.pagination.totalPages = res.totalPages;
          this.pagination.total = res.totalElements;
          if (this.pagination.page < this.pagination.totalPages - 1) {
            this.pagination.page ++
          } else {
            this.infiniteNomore = true;
          }
          this.infiniteLoading = false
        })
        .catch((err) => {
          this.infiniteLoading = false
          this.$message.error(err.message);
        });
    },
    /**
     * @description: 点击列表
     * @param {*}
     * @return {*}
     */
    toListDetail(item, index) {
      // console.log(item);
      this.isClick = true;
      this.groupUserList = []; // 邀请群成员入参列表
      this.groupUserNames = [];
      this.exceptionOrderNo = item.exceptionOrderNo;
      this.queryAbnormalDetail(item.exceptionOrderNo); // 请求异常单详情，成功后请求售后单详情
      this.queryAfterOrderDetail(item.businessKey);
      this.groupId = item.chatGroupId;
      for (const i in this.lists) {
        if (i == index) {
          this.lists[i].active = true;
        } else {
          this.lists[i].active = false;
        }
      }
      // this.allowCreateChat =
      //   !this.groupId &&
      //   item.businessKey.substr(0, 4).toLowerCase() === "asap" &&
      //   (item.status === 1 || item.status === 2); // 当前异常单是否可以创建群聊
      this.isChatShow =
        this.groupId && this.groupId !== '' && typeof (this.groupId) !== 'undefined' 
        // && item.businessKey.substr(0, 4).toLowerCase() === "asap" &&
        // (item.status === 1 || item.status === 2); // 当前异常单是否可以显示群聊
      if (this.isChatShow) {
        this.iframeUrl = `${CHAT_URL}?token=${this.TOKEN}&chatId=${this.myChatId}&index=${index}`;
      }
    },
     /**
     * @description: 初始化获取当前用户的信息
     * @param {*} params
     * @return {*}
     */
    initAllProfile() {
      // const params = {
      //   enable: this.enable,
      //   "departmentStrategy.all": this.departmentStrategy.all,
      //   "departmentStrategy.depth": this.departmentStrategy.depth.join(","),
      //   userTypes: this.userType,
      // };
      // profilesDefault(params)
      //   .then((res) => {
      //     const profiles = res || [];
      //     // 每次调用 profile 接口，都保存一份资料到本地（增量）
      //     this.saveProfileLls(res, "userProfiles");
      //   })
      //   .catch((err) => {
      //     this.$message.error(err.message);
      //   });
    },
    /**
     * @description: 获取 chatId
     * @param {*}
     * @return {*}
     */
    getChatId() {
      this.myChatId = localStorage.getItem("myChatId") || "";
    },
    /**
     * @description: 获取异常单详情
     * @param {*}
     * @return {*}
     */
    queryAbnormalDetail(id) {
      // const params = {
      //   exceptionOrderNo: id,
      // };
      getAbnormalDetail(id)
        .then((res) => {
          // console.log(res)
          this.abnormalOption = res || {};
          this.status = this.abnormalOption.status;
          // const handlerId = this.abnormalOption.handlerId;
          // this.queryAfterOrderDetail(res.businessKey);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    /**
     * @description: 查询售后单详情
     * @param {*}
     * @return {*}
     */
    queryAfterOrderDetail(id) {
      const params = {
        aftersalesNo: id,
      };
      getAfterOrderDetail(params)
        .then((res) => {
          // console.log(res);
          this.afterOrderOption = res || {};
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    /**
     * @description: 保存 profile 到 localStorage
     * @param {*}
     * @return {*}
     */
    saveProfileLls(list, llsName) {
      const userProfiles = JSON.parse(localStorage.getItem(llsName)) || {};
      for (const obj of list) {
        const temp = obj;
        userProfiles[obj.chatId] = temp;
      }
      localStorage.setItem(llsName, JSON.stringify(userProfiles));
      // 将父元素的 localStorage 同步到 iframe
      if (this.$refs.iframe) {
        const data = {
          name: llsName,
          data: list,
        };
        this.onPostMessage("updateLSprofiles", data);
      }
    },
    /**
     * @description: 发送本系统数据到聊天 iframe
     * @param {*}
     * @return {*}
     */
    onPostMessage(type, data) {
      this.$refs.iframe.contentWindow.postMessage(
        { type: type, data: data },
        "*"
      );
    },
        /**
     * @description: 获取默认的群聊用户
     * @param {*}
     * @return {*}
     */
    getUser() {
      const params = {
        exceptionOrderNo: this.exceptionOrderNo,
        userId: this.myUserId,
        userType: this.userType
      };
      getDefaultUser(params).then((res) => {
        this.addressList = (res || []).map((item) => {
          item.active = "unInvited";
          return item;
        });
        // 未创建群聊时不能发送，所以第一次不发送消息
        if (this.$refs.iframe) {
          // 当生成了 iframe 后才发送 postMessage
          const data = {
            addressList: this.addressList,
          };
          this.onPostMessage("updateDefaultUser", data);
        }
      });
    },
    /**
     * @description: 重置异常单详情为空
     * @param {*}
     * @return {*}
     */
    initAbnormalOption() {
      Object.assign(this.abnormalOption, {
        type: "",
        description: "",
        created: {
          createdAt: "",
          createdByName: "",
        },
        handler: {
          handler: "",
          lastUpdatedAt: "",
          resolutionTime: ""
        },
        operations: [],
        processStatus: "",
        status: "",
      })
    },
    /**
     * @description: 重置售后单详情为空
     * @param {*}
     * @return {*}
     */
    initAfterOrderOption() {
      Object.assign(this.afterOrderOption, {
        bianma: "",
        countMin: null,
        description: "",
        fromBillNo: "",
        iName: "",
        imgs: [],
        purchasePrice: null,
        totalMoney: null,
        unitName: "",
      })
    },
    /**
     * @description: 点击图片显示预览
     * @param {*} item
     * @return {*}
     */
    imagePreview(item) {
      this.imgPreview = true;
      this.dialogSrc = item;
    },
    /**
     * @description: 图片预览点击关闭
     * @param {*}
     * @return {*}
     */
    handleClose() {
      this.dialogSrc = '';
    }
  },
  filters: {
    /**
     * @description: 异常单状态对应文字
     * @param {Number} value
     */
    filterStatus(value) {
      const map = {
        1: "新建",
        2: "待确认",
        3: "已完成",
        4: "关闭",
      };
      return map[value];
    },
    /**
     * @description: 处理状态对应文字
     * @param {Number} value
     */
    filterType(value) {
      const map = {
        1: "售后问题",
        2: "订单问题",
        3: "发票问题",
        4: "账户问题",
        5: "产品问题",
        6: "其它问题",
      };
      return map[value];
    },
    /**
     * @description: 处理异常单状态对应文字
     * @param {Number} value
     */
    filterOrderType(value) {
      const map = {
        1: "退货",
        2: "换货",
        3: "维修",
        4: "发配",
        5: "换配",
      };
      return map[value];
    },
    /**
     * @description: 处理异常单状态对应颜色
     * @param {Number} value
     */
    filterOrderTypeColor(value) {
      const map = {
        1: "danger",
        2: "",
        3: "success",
        4: "warning",
        5: "info",
      };
      return map[value];
    },
  },
  destroyed () {
    eventBus.$off('rcdMsg')
  },
};
</script>

<style lang="scss" scoped>
.orderList {
  height: 100%;
  // height: calc(100vh - 120px);
  position: relative;
  .my-wrap {
    height: 100%;
  }
  .index-left {
    align-items: stretch;
    background-color: #fff;
    border-radius: 9px;
    height: 100%;
    overflow: hidden;
    .list-search {
      padding: 17px 15px;
      border-bottom: 1px solid #e9edec;
      .my-input {
        width: 100%;
        /deep/ .el-input__inner {
          width: 100%;
          height: 33px;
          background-color: #f3f7f6;
          border-radius: 17px;
          border-color: transparent;
        }
      }
    }
    .index-lists {
      // padding-bottom: 48px;
      height: 100%;
      box-shadow: 0px 0px 15px 0px rgba(63, 191, 127, 0.08);
      z-index: 1;
      .lists {
        height: calc(100vh - 200px);
        overflow-y: auto;
        & > ul {
          padding-left: 0px;
        }
      }
      .list {
        list-style-type: none;
        height: 66px;
        padding: 11px 14px 0 0px;
        border-bottom: 1px solid #e9edec;
        cursor: pointer;
        &.active {
          background: linear-gradient(236deg, #00d08b 0%, #00c097 100%);
          .list-title {
            color: #ffffff;
          }
          .list-subtitle {
            margin: 0;
            .list-desc {
              color: #ffffff;
            }
          }
          // .list-time {
          //   color: #ffffff;
          // }
        }
        .list-avatar {
          width: 45px;
          height: 45px;
          border-radius: 6px;
          margin-top: 3px;
          background: transparent;
        }
        .list-title {
          font-size: 12px;
          font-weight: 600;
          margin-top: 6px;
        }
        .list-subtitle {
          font-size: 11px;
          color: #888888;
          padding-top: 6px;
          .list-desc {
            margin-top: 5px;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
          }
        }
      }
    }
    .index-chat {
      height: 100%;
      .chatIframe {
        width: 100%;
        height: 100%;
      }
    }
  }
  .index-right {
    background-color: #fff;
    border-radius: 9px;
    .tabContent {
      padding: 20px;
      font-size: 12px;
      color: #333333;
      /deep/ .el-form-item__label {
        line-height: 30px;
        & > label {
          color: #777777;
        }
      }
      /deep/ .el-form-item__content {
        line-height: 30px;
      }
      .log-title {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
        margin-top: 20px;
        margin-bottom: 11px;
      }
      .log-content {
        padding: 17px 11px;
        border-radius: 8px;
        background-color: #f3f7f6;
        max-height: 450px;
        overflow-y: auto;
        ul {
          padding-left: 8px;
          .li {
            padding: 10px 0 15px 0;
            line-height: 1.5;
            position: relative;
            .log-time {
              position: absolute;
              right: 14px;
              top: 12px;
              color: #888888;
              font-size: 11px;
            }
            .log-avatar {
              width: 27px;
              height: 27px;
            }
            .log-name {
              font-size: 13px;
              color: #333333;
              margin-bottom: 6px;
            }
            .log-description {
              font-size: 12px;
              color: #555555;
            }
          }
        }
      }
    }
  }
  .small-image {
    width: 45px;
    height: 45px;
    border-radius: 6px;
    border: 1px solid #e2e2e2;
    margin-right: 11px;
  }
  .button-group {
    position: absolute;
    right: 20px;
    bottom: 30px;
  }
  .my-button {
    width: 102px;
    height: 30px;
    border-radius: 15px;
    border: 1px solid #dee4e3;
    color: #00be7e;
    font-size: 12px;
    &.hot {
      background: linear-gradient(270deg, #ffbd09 0%, #ffa305 100%);
      box-shadow: 0px 3px 6px 0px rgba(219, 162, 60, 0.27);
      color: #ffffff;
    }
    &.main {
      background: linear-gradient(236deg, #00d08b 0%, #00c097 100%);
      box-shadow: 0px 6px 12px 0px rgba(60, 223, 131, 0.27);
      color: #ffffff;
    }
  }
  .my-tag {
    font-size: 10px;
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
  }
  .not-chat-wrapper {
    padding: 50px 20px;
    text-align: center;
    color: #777777;
    font-size: 14px;
  }
}
.my-popover {
  min-height: 300px;
}
.empty-wrapper {
  text-align: center;
  min-height: 200px;
  padding-top: 35%;
  img {
    width: 54px;
  }
}
.clearfix {
  clear: both;
}
.custom-dialog {
  width: 680px;
  text-align: center;
  margin: 0 auto;
  overflow: hidden;
  img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/orderForChat/orderList.vue